<template>
  <div class="flex-grow-1">
    <header-bar />
    <purple-card :data="systemData" />
    <div class="py-5"></div>
    <carousel-card :data="systemData" v-if="systemData" />
    <bulk-content-card
      :content="systemData ? systemData.bulkContent : 'Loading...'"
    />
    <purple-card2 :data="systemData" />
    <footer-bar />
  </div>
</template>

<script>
  import headerBar from '@/components/shared/HeaderBar.vue';
  import footerBar from '@/components/shared/FooterBar.vue';
  import purpleCard from '@/components/systemDetails/PurpleCard.vue';
  import carouselCard from '@/components/systemDetails/CarouselCard.vue';
  import purpleCard2 from '@/components/systemDetails/PurpleCard2.vue';
  import BulkContentCard from '@/components/shared/BulkContentCard.vue';

  export default {
    props: {
      data: Object,
      systemName: String,
      venueName: String
    },
    data() {
      return {
        systemData: this.data
      };
    },
    metaInfo() {
      if (!this.systemData) {
        return {};
      }

      return {
        title: this.systemData.metaTitle,
        meta: [
          { name: 'title', content: this.systemData.metaTitle },
          { name: 'description', content: this.systemData.metaDescription }
        ]
      };
    },
    components: {
      headerBar,
      footerBar,
      purpleCard,
      carouselCard,
      purpleCard2,
      BulkContentCard
    },
    methods: {
      refreshSystemDetails() {}
    },
    computed: {
      pageData() {
        return this.data ? this.data : this.ajaxData;
      }
    },
    mounted() {
      if (!this.systemData && this.systemName) {
        this.$store
          .dispatch('configurator/getSystemDetails', {
            systemName: this.systemName,
            venue: this.venueName ? this.venueName : null
          })
          .then((response) => {
            this.systemData = response;
          })
          .catch((error) => {
            console.error('Error fetching system details', error);
            this.$router.push({ name: 'home' });
          });
      }
    }
  };
</script>

<style scoped></style>
